document.addEventListener('variant-selected', (event) => {

  const variantId = String(event.detail.variant.id);

  const tabs = document.querySelectorAll('.collapsible-tab__block');

  tabs.forEach(tab => {

    const variantList = tab.dataset.variants;

    // If tab has no restriction → always visible
    if (!variantList) {
      tab.style.display = '';
      return;
    }

    const allowedVariants = variantList.split(',');

    if (allowedVariants.includes(variantId)) {
      tab.style.display = '';
    } else {
      tab.style.display = 'none';
    }

  });

});

document.addEventListener('DOMContentLoaded', () => {

  const variantInput = document.querySelector('input[name="id"]');
  if (!variantInput) return;

  const variantId = variantInput.value;

  const tabs = document.querySelectorAll('.collapsible-tab__block');

  tabs.forEach(tab => {

    const variantList = tab.dataset.variants;

    if (!variantList) return;

    const allowedVariants = variantList.split(',');

    if (!allowedVariants.includes(variantId)) {
      tab.style.display = 'none';
    }

  });

});